import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import reducer from '../reducers/index'

const composeEnhancers =
  import.meta.env.DEV && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true })
    : compose

const configureStore = props => createStore(reducer, props, composeEnhancers(applyMiddleware(thunk)))

export default configureStore
